import { Box, Button, Typography } from '@mui/material';
import type { FC } from 'react';
import { useState } from 'react';
import toast from 'react-hot-toast';

type CommandBlockProps = {
  command: string;
  multiline?: boolean;
  onCopy?: () => void;
};

const CommandBlock: FC<CommandBlockProps> = ({ command, multiline = false, onCopy }) => {
  const [hovered, setHovered] = useState(false);

  const handleCopy = async () => {
    try {
      await navigator.clipboard.writeText(command);
      toast.success('Command copied to clipboard');
      onCopy?.();
    } catch {
      toast.error('Failed to copy command');
    }
  };

  return (
    <Box
      onMouseEnter={() => setHovered(true)}
      onMouseLeave={() => setHovered(false)}
      style={{
        position: 'relative',
        marginTop: 12,
        background: '#F7FAFC',
        border: '1px solid #E2E8F0',
        borderRadius: 4,
        padding: '12px 14px',
        minHeight: 48,
      }}
    >
      <Typography
        component="pre"
        style={{
          margin: 0,
          fontFamily: 'Consolas, Monaco, monospace',
          fontSize: 12,
          color: '#2D3748',
          whiteSpace: multiline ? 'pre-wrap' : 'pre-wrap',
          wordBreak: 'break-word',
          paddingRight: hovered ? 72 : 0,
        }}
      >
        {command}
      </Typography>
      {hovered && (
        <Button
          size="small"
          onClick={handleCopy}
          style={{
            position: 'absolute',
            top: 8,
            right: 8,
            textTransform: 'none',
            fontSize: 12,
            background: '#FFFFFF',
            border: '1px solid #CBD5E0',
            color: '#2D3748',
            minWidth: 56,
            padding: '2px 10px',
          }}
        >
          Copy
        </Button>
      )}
    </Box>
  );
};

export default CommandBlock;